import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceColor, shellMetrics } from '../tokens';

export const styledBackstageSidebarPage = (
  theme: Theme,
): BackstageOverrides['BackstageSidebarPage'] => ({
  root: {
    background: `linear-gradient(180deg, ${getSurfaceColor(
      theme,
      'subtle',
    )} 0%, ${theme.palette.background.default} 180px)`,
    '& > .bui-PluginHeader': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      height: '100dvh',
      overflow: 'hidden',
      paddingBottom: 0,
      '& > main[class*="BackstagePage-root"]': {
        height: `calc(100dvh - ${shellMetrics.mobileSidebarHeight}px - env(safe-area-inset-bottom))`,
        overflowX: 'hidden',
        overflowY: 'auto',
        overscrollBehaviorY: 'contain',
        WebkitOverflowScrolling: 'touch',
      },
    },
  },
});
